module.exports = __webpack_public_path__ + "img/BlinkArt_Sword11_Blood.0ef3b9a4.png";